import Image from '@repo/ui/src/components/Image';
import React from 'react';

import { Order, PaymentCard } from '@repo/ui/src/types/order';

export interface OrderSummaryPaymentInfoProps {
  paymentInstruments?: Order['details']['paymentInstruments'];
}

const OrderDetailPaymentInfo = ({ paymentInstruments }: OrderSummaryPaymentInfoProps) => {
  const cards = paymentInstruments?.reduce(
    (acc, { paymentCard }) => (paymentCard ? [...acc, paymentCard] : acc),
    [] as Array<PaymentCard>,
  );

  if (!cards?.length) {
    return null;
  }

  return (
    <div data-testid="order-summary-payment-info">
      <p className="tra-text-web-body-, font-bold mb-2">Payment Method</p>
      {cards?.map(({ numberLastDigits, expirationYear, expirationMonth, cardType }, key) => (
        <div key={key} className="flex items-start gap-x-3">
          <div className="flex gap-3 items-center">
            <div>
              <Image
                className="w-11"
                src={`/images/cards/${cardType}.png`}
                alt={cardType}
                width={42}
                height={29}
              />
            </div>

            <div>
              <p className="tra-text-web-body-, mb-0">
                Ending with <span className="font-bold">{numberLastDigits}</span>
              </p>
              <p className="tra-text-web-body-, mb-0">
                Expires{' '}
                <span className="font-bold">
                  {expirationMonth}/{expirationYear}
                </span>
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderDetailPaymentInfo;
